<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->
  <div class="flex flex-col gap-4 md:gap-8">
    <RevSkeleton v-if="pending" height="100px" shape="rectangle" width="100%" />

    <template v-if="!pending">
      <AIText v-if="aiSummary?.text" :text="aiSummary.text">
        <template #info>
          <AIInfo
            class="hidden md:block"
            :reviews-count="aiSummary?.reviewsCount"
            :updated-at="aiSummary?.updatedAt"
          />
        </template>
      </AIText>

      <AIInfo
        class="md:hidden"
        :reviews-count="aiSummary?.reviewsCount"
        :updated-at="aiSummary?.updatedAt"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ReviewsAISummary } from '@backmarket/http-api/src/api-specs-reviews/types/ai-summary'
import { RevSkeleton } from '@ds/components/Skeleton'

import AIInfo from '../AIInfo/AIInfo.vue'
import AIText from '../AIText/AIText.vue'

defineProps<{
  aiSummary: ReviewsAISummary | undefined | null
  pending: boolean
}>()
</script>
